import { JetView, plugins } from 'webix-jet'; // Import necessary modules from webix-jet
import { devConfig } from 'config/config'; // Import development configuration
import MenuView from 'jet-views/menu'; // Import MenuView component
import ToolView from 'jet-views/toolbar'; // Import ToolView component

/**
 * Class representing the products view.
 * @extends JetView
 */
export default class productsView extends JetView {
    /**
     * Configures the UI components for the products view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const screen = this.app.config.size; // Current screen size
        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            type: 'clean', // Clean layout type
            view: 'form', // Form view
            id: 'a10', // Unique identifier for the form
            scroll: 'y', // Enable vertical scrolling
            rows: [
                {
                    type: 'wide', // Wide layout type
                    responsive: 'a10', // Responsive layout identifier
                    margin: 10, // Margin around the layout
                    cols: [
                        {
                            localId: 'inner:layout', // Local identifier for inner layout
                            gravity: 4, // Gravity for resizing
                            type: 'wide', // Wide layout type
                            rows: [
                                {
                                    view: 'tabbar', // Tab bar component
                                    localId: 'tabbar', // Local identifier for tab bar
                                    height: screen == 'small' ? 75 : 45, // Dynamic height based on screen size
                                    options: [
                                        {
                                            id: 'machine.products2.partnersProducts', // Identifier for the first tab
                                            value: _('Máquina Productos'), // Localized value for the first tab
                                        },
                                        {
                                            id: 'machine.products2.partnersGames', // Identifier for the second tab
                                            value: _('Ordenar Juegos'), // Localized value for the second tab
                                        },
                                    ],
                                },
                                { $subview: true }, // Placeholder for subview
                            ],
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the products view.
     */
    init() {
        this.use(plugins.Menu, this.$$('tabbar')); // Use the Menu plugin with the tab bar
    }
}

// FILE DOCUMENTED
